import { create } from "zustand";
import { type EditableUser, getEditableUsers } from "@/features/user/get-editable-users";

type Store = {
  token: string;
  whoami: EditableUser | null;
  profileImage: string;
  selectedUserId: string | null;
};

type Actions = {
  setToken: (token: string) => void;
  setWhoami: (whoami: EditableUser | null) => void;
  setProfileImage: (profileImage: string) => void;
  setSelectedUserId: (id: string | null) => void;
};

export const useAuthStore = create<Store & Actions>()((set) => ({
  token: "",
  setToken: (newToken) => set(() => ({ token: newToken })),
  whoami: null,
  profileImage: "",
  selectedUserId: null,
  setWhoami: (newWhoami) =>
    set((state) => {
      const users = getEditableUsers(newWhoami);
      const currentIsValid =
        state.selectedUserId != null && users.some((u) => u.id === state.selectedUserId);
      return {
        whoami: newWhoami,
        selectedUserId: currentIsValid ? state.selectedUserId : (newWhoami?.id ?? null)
      };
    }),
  setProfileImage: (newProfileImage) => set(() => ({ profileImage: newProfileImage })),
  setSelectedUserId: (id: string | null) => set(() => ({ selectedUserId: id }))
}));
